<template>
  <div class="page-clients page-layout">

    <!-- Page Title -->
    <div class="page-layout__container page-title">
      <div class="container">
        <div class="row page-layout__content flex-column">
          <h1>
            Clientes Satisfechos
          </h1>
          <p>
            Estos son algunos de los clientes que confían en nosotros
          </p>
        </div>
      </div>
    </div>

    <!-- Ours Clients -->
    <div class="ours-clients">
      <div class="page-layout__container pt-0">
        <div class="container">
          <!-- Logo Clients -->
          <div class="row layout--carousel">
            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_4_la-sirena.png"
                alt="Logo La Sirena"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_next.png"
                alt="Logo Next"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_5_propagas.png"
                alt="Logo Propagas"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_imca_cat.png"
                alt="Logo IMCA Cat"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_tropigas-_rd.png"
                alt="Logo Tropigas"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_induban.png"
                alt="Logo Induban"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_total_energies.png"
                alt="Logo Total Energies"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_1_banco-central.jpg"
                alt="Logo Banco Central"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_2_calizamar.png"
                alt="Logo Calizamar"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_8_gb-energy.jpg"
                alt="Logo Gb Energy"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_mcdonalds_rd.png"
                alt="Logo McDonalds"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_coastal.png"
                alt="Logo Coastal"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_shell.png"
                alt="Logo Shell"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_multicereales.png"
                alt="Logo Multicereales"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_strata.png"
                alt="Logo Strata"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_6_sgn.jpg"
                alt="Logo SGN"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_sunix.png"
                alt="Logo Sunix"
                style="max-height:140px;"
              />
            </div>

            <div
              class="col layout--card"
              v-scroll="handleScroll"
              data-scroll-class="animated zoomIn"
              data-scroll-button-distance="400"
              data-scroll-once="true"
              duration="5000"
            >
              <img
                src="../../src/assets/images/clients/logo_3_esso.png"
                alt="Logo Esso"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quotes -->
    <div class="light--bg-blue">
      <section-quotes />
    </div>
  </div>
</template>

<script>
import SectionQuotes from '@/components/layout/body-sections/section-quotes.vue';

export default {
  name: 'Clientes',
  components: {
    SectionQuotes,
  },
};
</script>
<style lang="scss" scoped>
.ours-clients {
  .layout--card {
    margin: 10px;
  }
}
</style>
